import { UNIT_TYPES } from '@/config/unitTypes.constants';

// The Link existing shipment popup: one alert per mismatched attribute, then the row's details.

// The six the design annotates; the server names the attribute, this names it in the user's words.
const ATTRIBUTE_LABEL_KEYS = Object.freeze({
  ghgEmissions: 'FIELD_GHG_EMISSIONS',
  ghgSavings: 'LINK_SHIPMENTS_COL_GHG_SAVINGS',
  rawMaterialType: 'FIELD_RAW_MATERIAL_TYPE',
  countryOfOrigin: 'FIELD_COUNTRY_OF_ORIGIN',
  allocationPreference: 'FIELD_ALLOCATION_PREFERENCE',
  feedstockCategory: 'FIELD_FEEDSTOCK_CATEGORY',
});

const QUANTITY_HEADING_KEYS = Object.freeze({
  [UNIT_TYPES.working]: 'SECTION_QUANTITY_IN_WORKING_UNIT',
  [UNIT_TYPES.declaration]: 'SECTION_QUANTITY_IN_DECLARATION_UNIT',
  [UNIT_TYPES.tracking]: 'SECTION_QUANTITY_IN_TRACKING_UNIT',
});

/** One warning per attribute the shipment disagrees with the order on; informational only. */
export const buildSustainabilityMismatches = (t, row) =>
  (row?.sustainabilityMismatches ?? [])
    .filter((mismatch) => ATTRIBUTE_LABEL_KEYS[mismatch.attribute])
    .map((mismatch) => ({
      id: mismatch.attribute,
      type: 'SUSTAINABILITY_MISMATCH',
      message: t('ALLOCATIONS_SUSTAINABILITY_MISMATCH', {
        attribute: t(ATTRIBUTE_LABEL_KEYS[mismatch.attribute]),
        shipmentValue: mismatch.shipmentValue ?? '-',
        orderValue: mismatch.orderValue ?? '-',
      }),
    }));

export const buildLinkShipmentDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_STATUS'), value: row.status },
        { label: t('FIELD_SENT_BY'), value: row.sentBy },
        { label: t('FORM_SHIPPING_SITES'), value: row.shippingSite },
        { label: t('FIELD_RECEIVED_AT'), value: row.receivedAt },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: row.dateOfDispatch },
      ],
    },
    {
      title: t(QUANTITY_HEADING_KEYS[unitType] ?? QUANTITY_HEADING_KEYS[UNIT_TYPES.declaration]),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        { label: t('FIELD_PENDING_QUANTITY'), value: unit.pendingQuantity },
      ],
    },
  ];
};
